var riot = require("riot");

riot.tag2('ahv-loading-indicator', '<div id="ahv-loading-indicator" show="{loading}"> <img src="assets/images/loading-indicator.gif"> </div>', '', '', function(opts) {
    require("./LoadingIndicatorController").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/loadingIndicator/ahv-loading-indicator.tag
 ** module id = 85
 ** module chunks = 0
 **/